import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Column from 'Shared/components/PagedView/Column';
import {withStringFilterProperties} from 'Shared/components/PagedView/Filter';
import {withValueChangedHook} from 'Shared/utilities/withValueChanged';
import './Keywords.sass';
import {searchKeywords, changeKeywordsFilters} from 'GenericTexting/ducks/keyword';
import ModularHost from 'Shared/components/ModularHost/ModularHost';
import ToolbarHeader from 'Shared/components/Toolbar/ToolbarHeader';
import PagedView from 'Shared/components/PagedView/PagedView';

const Keywords = () => {
  const dispatch = useDispatch();
  const {filter, keywordPage} = useSelector((state: ReducerState) => state.keywords);

  const changeFilter = withValueChangedHook(filter, changeKeywordsFilters, dispatch);
  const filterProperties = {
    changeFilter,
    filterData: filter,
  };

  useEffect(() => {
    dispatch(searchKeywords(undefined, filter));
  }, [dispatch, filter]);

  return (
    <ModularHost>
      <ToolbarHeader title="Keywords" />
      <PagedView pagedViewKey="keywords" loadMore={page => dispatch(searchKeywords(page, filter))} data={keywordPage}>
        {columnProps => (
          <>
            <Column
              {...columnProps}
              title="Keyword"
              filterProperties={withStringFilterProperties(filterProperties, 'keywordName')}
              default
            >
              {keyword => keyword.keywordName}
            </Column>
            <Column
              {...columnProps}
              title="Client Name"
              filterProperties={withStringFilterProperties(filterProperties, 'clientName')}
              default
            >
              {keyword => keyword.client!.clientName}
            </Column>
          </>
        )}
      </PagedView>
    </ModularHost>
  );
};

export default Keywords;
